"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THEME_SCOPE_ID = exports.THEME_ROOT_SELECTOR = exports.CONTEXT_NOT_FOUND_ERROR_MESSAGE = void 0;
const CONTEXT_NOT_FOUND_ERROR_MESSAGE = exports.CONTEXT_NOT_FOUND_ERROR_MESSAGE = 'StencilComponents must be used within the descendant of a StencilProvider.';
const THEME_SCOPE_ID = exports.THEME_SCOPE_ID = 'data-stencil-theme-scope-id';
const THEME_ROOT_SELECTOR = exports.THEME_ROOT_SELECTOR = ':root';